const REVISION_DIFF_FIELDS = ['title', 'bullets', 'description', 'aplus', 'searchTerms', 'qa'];

const REVISION_DIFF_LABELS = {
  title: '标题',
  bullets: '五点',
  description: '商品描述',
  aplus: 'A+ 模块',
  searchTerms: 'Search Terms',
  qa: 'QA',
};

export function stringifyRevisionSectionValue(section, value) {
  if (section === 'title') return [value?.titleEn || '', value?.titleSub || ''].join('\n');
  if (section === 'bullets') return (value?.bulletsEn || []).join('\n');
  if (section === 'description') return value?.descriptionEn || '';
  if (section === 'aplus') return JSON.stringify(value?.aplusModules || []);
  if (section === 'searchTerms') return value?.searchTermsEn || '';
  if (section === 'qa') {
    const qa = Array.isArray(value) ? value : [];
    return qa.map((item) => [
      `Q: ${item.questionEn || item.question || ''}`,
      `A: ${item.answerEn || item.answer || ''}`,
    ].join('\n')).join('\n\n');
  }
  return '';
}

export function deriveRevisionChangedFields({ normalized = {}, currentDraft = {} } = {}) {
  const candidates = {
    title: normalized.title,
    bullets: normalized.bullets,
    description: normalized.description,
    aplus: normalized.description,
    searchTerms: normalized.searchTerms,
    qa: normalized.qa,
  };
  const hasCandidate = {
    title: Boolean(normalized.title),
    bullets: Boolean(normalized.bullets),
    description: Boolean(normalized.description && Object.hasOwn(normalized.description, 'descriptionEn')),
    aplus: Boolean(normalized.description && Array.isArray(normalized.description.aplusModules)),
    searchTerms: Boolean(normalized.searchTerms),
    qa: Array.isArray(normalized.qa),
  };
  const current = {
    title: currentDraft.title,
    bullets: currentDraft.bullets,
    description: currentDraft.description,
    aplus: currentDraft.description,
    searchTerms: currentDraft.searchTerms,
    qa: currentDraft.qa,
  };
  return REVISION_DIFF_FIELDS.filter((field) => (
    hasCandidate[field]
    && stringifyRevisionSectionValue(field, candidates[field]).trim()
      !== stringifyRevisionSectionValue(field, current[field]).trim()
  ));
}

function clipRevisionDiffText(value, max = 260) {
  const text = String(value || '').replace(/\s+/g, ' ').trim();
  return text.length <= max ? text : `${text.slice(0, max)}...`;
}

export function buildRevisionDiffItems(currentDraft = {}, nextDraft = {}) {
  const next = { ...nextDraft, aplus: nextDraft?.description };
  const current = { ...currentDraft, aplus: currentDraft?.description };
  return REVISION_DIFF_FIELDS.map((key) => {
    const before = stringifyRevisionSectionValue(key, current[key]).trim();
    const after = stringifyRevisionSectionValue(key, next[key]).trim();
    if (before === after) return null;
    return {
      key,
      label: REVISION_DIFF_LABELS[key] || key,
      before: clipRevisionDiffText(before) || '空',
      after: clipRevisionDiffText(after) || '空',
    };
  }).filter(Boolean);
}

/** Keeps revision diff calculation and the Step03 notice renderer independently testable. */
export function createRevisionDiffController({
  getCurrentDraft,
  renderNotice = () => {},
} = {}) {
  function buildItems(nextDraft) {
    return buildRevisionDiffItems(getCurrentDraft?.() || {}, nextDraft);
  }

  return {
    buildItems,
    hasMeaningfulDiff: (nextDraft) => buildItems(nextDraft).length > 0,
    renderNotice: (items, execution) => renderNotice(items, execution),
  };
}
